import React from "react";
import "./org.css";
import { OrganisationsLinks } from "./Org.js";
function KCYM() {
    return (
        <div>
            <div class="content1">
                <OrganisationsLinks />
                <h2>K.C.Y.M</h2>
                <div class="org-portion">
                    <div class="org-left">
                        <img src="/images/Logo.png" alt="Logo 2024 - 25" />
                    </div>
                    <div class="org-right">
                        <div class="org-descp">
                            <h4>Logo Name</h4>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!</p>
                        </div>
                    </div>
                </div>
                <div class="unit-group">
                    <img src="/images/cat-gp.jpg" alt="K.C.Y.M Members" />
                    <h3>K.C.Y.M Members</h3>
                </div>
                <div class="members-table" style={{ marginBottom: 0 }}>
                    <table border="1">
                        <tr>
                            <th>Position</th>
                            <th>Name</th>
                            <th>Contact Number</th>
                        </tr>
                        <tr>
                            <td>President</td>
                            <td>Name 1</td>
                            <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                        </tr>
                        <tr>
                            <td>Vice President</td>
                            <td>Name 2</td>
                            <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                        </tr>
                        <tr>
                            <td>Secretary</td>
                            <td>Name 3</td>
                            <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                        </tr>
                        <tr>
                            <td>Treasurer</td>
                            <td>Name 4</td>
                            <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                        </tr>
                    </table>
                </div>
                <div class="org-gallery">
                    <hr></hr>
                    <h5>Gallery</h5>
                    <div class="org-boxesm">
                        <div class="org-iboxm">
                            <img src="/images/Vasupuram Church.jpg" alt="St. Antony's Church" />
                            <img src="/images/antony.jpg" alt="St. Antony's Church" />
                            <img src="/images/Vasupuram Church.jpg" alt="St. Antony's Church" />
                            <img src="/images/cat-gp.jpg" alt="St. Antony's Church" />
                        </div>
                        <div class="org-iboxm">
                            <img src="/images/Vasupuram Church.jpg" alt="St. Antony's Church" />
                            <img src="/images/antony.jpg" alt="St. Antony's Church" />
                            <img src="/images/Vasupuram Church.jpg" alt="St. Antony's Church" />
                            <img src="/images/cat-gp.jpg" alt="St. Antony's Church" />
                        </div>
                    </div>
                </div>
            </div>
            <footer>
                <h1>Quick Links</h1>
                <ul>
                    <li><a href="https://www.vatican.va/content/vatican/en.html" className="catechism-link">Vatican</a></li>
                    <li><a href="https://www.cbci.in/" className="catechism-link">CBCI</a></li>
                    <li><a href="https://kcbc.co.in/" className="catechism-link">KCBC</a></li>
                    <li><a href="https://www.syromalabarchurch.in/" className="catechism-link">Syro-Malabar Church</a></li>
                    <li><a href="https://www.syromalabarcatechesis.com/" className="catechism-link">Syro-Malabar Catechism</a></li>
                    <li><a href="https://irinjalakudadiocese.com/" className="catechism-link">Irinjalakuda Diocese</a></li>
                    <li><a href="https://vidyajyotiijk.com/" className="catechism-link">Vidyajyoti Catechism</a></li>
                </ul>
                <ul>
                    <li><a href="https://www.instagram.com/kcym__vasupuram__?igsh=MWZqZWEzajZ4Zzl1OQ==" className="catechism-link"><img src="/images/insta.png" alt="KCYM Vasupuram" style={{ width: "20px", height: "20px", marginRight: "5px", marginBottom: "-3px" }} />K.C.Y.M Vasupuram</a></li>
                    <li><a href="https://www.facebook.com/share/15sdkwiTG8/" className="catechism-link"><img src="/images/face.png" alt="KCYM Vasupuram" style={{ width: "18px", height: "18px", marginRight: "3px", marginBottom: "-2px" }} />K.C.Y.M Vasupuram</a></li>
                    <li><a href="https://www.youtube.com/@kcymvasupuram9096" className="catechism-link"><img src="/images/youtube.png" alt="KCYM Vasupuram" style={{ width: "20px", height: "20px", marginRight: "5px", marginBottom: "-3px" }} />K.C.Y.M Vasupuram</a></li>
                </ul>
            </footer>
        </div>
    );
};
export default KCYM;